import { IRoute } from "shared/interface/types";
import { PartnerProviderRoutes } from "./partnerRoute";
export const PartnerRoutes: IRoute[] = [...PartnerProviderRoutes];
